import { config } from 'state/attributeGroup/config'
import { Attribute } from 'state/attribute'
import { Product } from 'state/product'
import 'state/utils/set'
import 'state/attributeGroup/events/initialize'

export class AttributeGroup {
  constructor(group) {
    Object.assign(this, {
      attributes: [],
      id: `${group.id}`,
      is: {
        active: true,
        abbreviated: false,
        collapsed: true,
        highlighted: false,
        selected: false
      },
      name: group.name,
      nodes: {
        container: AttributeGroup.nodes.container.cloneNode(false),
        attributes: AttributeGroup.nodes.attributes.cloneNode(false),
        title: AttributeGroup.nodes.title.cloneNode(false)
      },
      selected: {
        aliases: new Set(),
        attributes: [],
        colors: new Set(),
        productIDs: new Set()
      },
      sortOrder: group.sortOrder
    })

    group.attributes.forEach(attribute => new Attribute(attribute, this))
    this.is.abbreviated = this.is.abbreviated || this.attributes.filter(attribute => attribute.is.active).length > config.thresholds.abbreviatedAttributes


    // this.nodes.container.setAttribute('data-id', `${this.id}`)
    this.nodes.container.id = `group-${this.id}`
    this.selected.attributes.length > 0 ? this.nodes.title.setAttribute('data-count', `${this.selected.attributes.length}`) : this.nodes.title.removeAttribute('data-count')
    this.nodes.title.innerHTML = this.name
    this.nodes.title.group = this
    this.nodes.container.group = this

    // this.nodes.attributes.onclick = () => {
    //   console.log('========================Attribute Group Click========================')
    //   if (this.is.abbreviated) {
    //     this.is.abbreviated = false
    //     this.updateClasses()

    //     // AttributeGroup.updateDOM()
    //   }
    // }

    this.nodes.container.appendChild(this.nodes.title)
    this.nodes.container.appendChild(this.nodes.attributes)
    // AttributeGroup.container = AttributeGroup.container || document.getElementById(config.selectors.id.groups)
    // AttributeGroup.container.appendChild(this.nodes.container)
  }
  clearSelections () {
    MK.events.emit('attribute:group:clearSelections', {
      target: this
    })
  }
  syncWithDOM () {
    // console.log('syncWithDOM (1)')

    if (!this.isActive()) return
    // console.log('syncWithDOM (2)', this)

    // let parentNode = AttributeGroup.container || document.getElementById(config.selectors.id.groups)

    this.selected.attributes.length > 0 ? this.nodes.title.setAttribute('data-count', `${this.selected.attributes.length}`) : this.nodes.title.removeAttribute('data-count')
    // Sync each attribute of the current group
    this.attributes.filter(attribute => attribute.is.active).forEach(attribute => {
      if (attribute.activeCounts) {
        // console.log('Product.display.by.id', Product.display.by.id)
        attribute.count = Product.display.by.id ? attribute.activeCounts.productIDs : attribute.activeCounts.aliases
        attribute.is.active = attribute.count > 0 || attribute.is.selected
        // console.log(`${attribute.name}, Count:`, attribute.count, attribute.activeCounts)
      }
    })

    // Update node class names
    this.updateClasses()

    // Remove attributes from the DOM
    while (this.nodes.attributes.firstChild) {
      this.nodes.attributes.removeChild(this.nodes.attributes.firstChild)
    }

    this.attributes.forEach(attribute => attribute.is.active && attribute.syncWithDOM(this.nodes.attributes))
    // this.attributes.filter(attribute => attribute.is.active || attribute.is.selected).forEach(attribute => {
    //   attribute.syncWithDOM(this.nodes.attributes)
    // })

    AttributeGroup.container = AttributeGroup.container || document.getElementById(config.selectors.id.groups)
    AttributeGroup.container.appendChild(this.nodes.container)
  }
  toggle (property, value) {
    MK.events.emit('attribute:group:toggle', {
      target: this,
      property: property,
      value: value
    })

    this.updateClasses()

    return true
  }
  updateSelections () {
    MK.events.emit('attribute:group:updateSelections', {
      target: this
    })
  }
  updateClasses () {
    let state = this.is.collapsed && this.is.highlighted && 'highlighted visible collapsed' || this.is.collapsed && 'collapsed' || this.is.highlighted && 'highlighted visible' || ''
    for (let [nodeName, node] of Object.entries(this.nodes)) {
      node.className = `${config.classes[nodeName]} ${state}`
    }

    if (this.is.abbreviated && this.attributes.filter(attribute => attribute.is.active || attribute.is.selected).length >= config.thresholds.abbreviatedAttributes) {
      this.nodes.attributes.className += ' abbreviated showMore'
    }
  }
  isActive() {
    this.is.active = this.is.selected || !!this.attributes.find(attribute => attribute.is.selected || attribute.is.active && attribute.count > 0)
    return this.is.active
  }
}





AttributeGroup.eventMonitor = function (e) {
  e && e.preventDefault && e.preventDefault()

  console.log(`DEBUG (state.attributeGroup.eventMonitor): Node Name: ${e.target.nodeName}, Event and target below:`)
  console.log(e)
  console.log(e.target)

  if (e.target && e.target.group) {
    e.target.group.toggle('collapsed')
    e.target.group.toggle('highlighted')
    // MK.events.emit('attribute:group:toggle', {
    //   target: e.target.group,
    //   property: 'collapsed',
    //   value: null
    // })

    // MK.events.emit('attribute:group:toggle', {
    //   target: e.target.group,
    //   property: 'highlighted',
    //   value: null
    // })


    // MK.events.emit('attribute:group:toggle', {
    //   target: e.target.group,
    //   property: 'highlighted',
    //   value: null
    // })

    MK.events.emit('attribute:groups:updateDOM', {
      initiator: 'AttributeGroup.eventMonitor'
    })
  } else if (e.target.attribute) {
    // Handle attribute clicks
    MK.events.emit('attribute:toggle', {
      target: e.target.attribute,
      property: 'selected'
    })
    // e.target.attribute.toggle('selected')
  }

  return false
}



AttributeGroup.addEventListeners = function () {

  const eventListeners = {
    clearAllSelections: {
      fn: (event = {}) => MK.events.emit('attribute:groups:clearAllSelections', event),
      selectors: ['clear-all-link', 'clear-all-link-mobile'],
      type: 'click'
    },
    // toggleCollapsed: {
    //   fn: AttributeGroup.toggleCollapsed,
    //   selectors: ['collapse-all-link'],
    //   type: 'click'
    // },
    // toggleExpanded: {
    //   fn: AttributeGroup.toggleExpanded,
    //   selectors: ['expand-all-link'],
    //   type: 'click'
    // },
    toggleRefineByMenu: {
      fn: (event = {}) => MK.events.emit('attribute:groups:toggleRefinementMenu', event),
      selectors: ['apply-selections', 'close-refinements', 'refinement-filters'],
      type: 'click'
    },
    attributeSelections: {
      fn: AttributeGroup.eventMonitor,
      selectors: ['attribute-groups'],
      type: 'click'
    }
  }


  console.log('DEBUG (attribute.groups.addEventListeners): Adding attribute group event listeners.')

  for (let [_id, event] of Object.entries(eventListeners)) {
    event.selectors.forEach(selector => {
      try {
        let element = MK.DOM.fns.getElementById(selector) // document.getElementById(selector)
        if (!element) throw new Error(`!!! ERROR (state.attributeGroup.addEventListeners) Error adding event listeners.  Element for ${_id} does not exist.`)
        element && element.addEventListener(event.type, event.fn, false)
      } catch (error) {
        console.log('!!! ERROR (attribute.groups.addEventListeners) Error adding event listeners.')
        console.log(error)
        MK.captureException(error)
      }
    })
  }
}

Attribute.index = {}
AttributeGroup.nodes = {
  span: document.createElement('span'),
  container: document.createElement('div'),
  attributes: document.createElement('ul'),
  title: document.createElement('h3')
}
AttributeGroup.elements = []
AttributeGroup.selected = {}
AttributeGroup.container = document.getElementById(config.selectors.id.groups)
